import workspaceQuery from 'graphql/queries/product/PromotionalPriceWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/PromotionalPriceListQuery.graphql';
import instanceQuery from 'graphql/queries/product/PromotionalPriceQuery.graphql';
import defaultQuery from 'graphql/queries/product/PromotionalPriceDefault.graphql';
import mutationQuery from 'graphql/mutations/product/PromotionalPriceMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/product/PromotionalPriceTempMutation.graphql';
import fragment from 'graphql/fragments/product/PromotionalPriceFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PromotionalPrice: EntityType = {
  type: 'PromotionalPrice',
  title: 'Promotional Prices',
  formTitle: 'Promotional Price',
  formUrl: '/Products/PromotionalPrices/Details/',
  workspaceUrl: '/Sales/CustomerPricing/PromotionalPrices/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'customer',
  },
  fragment,
  screenReference: 'PROMOTIONAL_PRICES',
};

export default PromotionalPrice;
